import { useEffect } from "react";
import { getHost } from "./getHost";
import type { BulkSelectionState } from "./teamAppZoid";

// AHA-41755 bulk-action bridge — embed → host.
//
// Reports the current bulk-selection state to the presenter every time it
// changes. The presenter uses the cohort counts to decide whether to show
// the sticky bar and which buttons to render. No-op when running standalone
// (no host), so the embed degrades cleanly during local dev — selection
// still works, the bar just doesn't appear (the presenter is the only
// place that renders it).
export function useHostReportSelection(state: BulkSelectionState): void {
  const { selectedIds, assignableCount, revocableCount, availableLicenses } =
    state;
  // Stable string key for the effect dep — selectedIds is a new array
  // every render, so without this we'd fire on every parent re-render
  // even when membership hasn't changed.
  const idsKey = selectedIds.join(",");
  useEffect(() => {
    const host = getHost();
    host?.onSelectionChange?.({
      selectedIds,
      assignableCount,
      revocableCount,
      availableLicenses,
    });
    // selectedIds intentionally excluded — idsKey is the canonical signal.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idsKey, assignableCount, revocableCount, availableLicenses]);
}
